import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import Enums from "../../configs/Enums";
import Utils from "../../configs/Utils";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";

const WorkspaceForm = ({ setPopupShow, refreshList }) => {
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      toast.error("Workspace name is required.");
      return;
    }

    setLoading(true);
    try {
      const response = await Utils._apiRequest({
        path: Enums.endpoints.workspace.ALL,
        type: "POST",
        payload: {
          name: formData.name,
          description: formData.description,
          ownerId: currentUser?._id,
        },
      });

      if (response && response.data) {
        toast.success("Workspace created successfully.");
        setPopupShow(false);
        refreshList(); // trigger list reload
      } else {
        toast.error("Failed to create workspace.");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="workspaceName">
        <Form.Label>
          Workspace Name <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="text"
          name="name"
          placeholder="Enter workspace name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="workspaceDesc">
        <Form.Label>Description</Form.Label>
        <Form.Control
          as="textarea"
          name="description"
          placeholder="Optional description"
          value={formData.description}
          onChange={handleChange}
          rows={3}
        />
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          className="me-2"
          onClick={() => setPopupShow(false)}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "Create Workspace"
          )}
        </Button>
      </div>
    </Form>
  );
};

export default WorkspaceForm;
